import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const aceptarHoraExtra = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/turnos/horasExtras/aceptar`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const rechazarHoraExtra = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/turnos/horasExtras/rechazar`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerHoraExtraEnEspera = () => {
    return axios.get(`${API_URL}/turnos/horasExtras/gerente`, {
        headers: getHeaders(),
    });
};
